import existy from '../../utils/existy';

const PREFIX = 'rmp-';

export function storeData(key, value) {
   try {
      localStorage.setItem(PREFIX + key, value);
   } catch (e) {
      //
   }
}

export function getStoredData(key, defaultValue) {
   try {
      const res = localStorage.getItem(PREFIX + key);
      return existy(res) ? res : defaultValue;
   } catch (e) {
      return defaultValue;
   }
}
